import React from 'react';
import ImagingOrderList from '../components/ImagingOrderList';

const ImagingOrderListPage: React.FC = () => <ImagingOrderList />;

export default ImagingOrderListPage;
